import { render } from "./Doughnut.vue?vue&type=template&id=c5cf7938"
import script from "./Doughnut.vue?vue&type=script&lang=js"
export * from "./Doughnut.vue?vue&type=script&lang=js"

import "./Doughnut.vue?vue&type=style&index=0&id=c5cf7938&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__